<template>
    <v-container class="pa-5" fluid>
        <ImportShippingLabelDialog
            :is-open="showImportShippingLabelDialog"
            :create-from="createFrom"
            @on-submit="submitCreateShippingLabel"
            @on-close="closeImportShippingLabelDialog"
        />

        <CarrierLabelDialog
            :is-open="showCarrierLabelDialog"
            :action-loading="carrierLabelLoading"
            :carrier-label-data="carrierLabel"
            @on-submit="submitCarrierLabel"
            @on-print="printCarrierShippingLabel"
            @on-close="closePrintCarrierLabelDialog"
        />
        <AdditionalShippingLabelDialog
            :is-open="additionalShippingLabelDialog"
            :action-loading="additionalShippingLabelLoading"
            :additional-shipping-label-data="additionalShippingLabel"
            :pallets="pallets"
            :destinations="destinations"
            @on-submit="submitAdditionalShippingLabel"
            @on-print="printAdditionalShippingLabel"
            @on-close="closeAdditionalShippingLabelDialog"
        />
        <CampaignShippingLabelDialog
            :is-open="campaignShippingLabelDialog"
            @on-close="closeCampaignShippingLabelDialog"
        />
        <ConfirmDialog
            :is-open="confirmDeleteShippingLabelDialog"
            :data="currentShippingLabel"
            :action-loading="actionLoading.deleteShippingLabel"
            removal
            @on-confirm="deleteShippingLabel"
            @on-abort="closeConfirmDeleteShippingLabelDialog"
        >
            <template #title>
                Usuwanie zawieszki
            </template>
            <template #content>
                Czy na pewno chcesz usunąć zawieszkę?
            </template>
            <template #confirmButton>
                Usuń
            </template>
        </ConfirmDialog>
        <v-row align="center" dense>
            <v-col cols="auto">
                <page-title>Zawieszki / Etykiety</page-title>
            </v-col>
        </v-row>

        <v-row justify="start">
            <v-col cols="12">
                <v-btn
                    color="secondary"
                    medium
                    class="mr-4"
                    data-sentry-label="Zawieszka z zamówienia"
                    @click="openImportShippingLabelDialog('EcommerceOrder')"
                >
                    <v-icon left>
                        mdi-plus
                    </v-icon>
                    Zawieszka z zamówienia
                </v-btn>
                <v-btn
                    color="secondary"
                    medium
                    class="mr-4"
                    data-sentry-label="Zawieszka z ZS"
                    @click="openImportShippingLabelDialog('ShipmentsOrder')"
                >
                    <v-icon left>
                        mdi-plus
                    </v-icon>
                    Zawieszka z ZS
                </v-btn>
                <v-btn
                    color="secondary"
                    medium
                    class="mr-4"
                    data-sentry-label="Etykieta kurierska"
                    @click="openPrintCarrierLabelDialog()"
                >
                    <v-icon left>
                        mdi-plus
                    </v-icon>
                    Etykieta kurierska
                </v-btn>
                <v-btn
                    color="secondary"
                    medium
                    class="mr-4"
                    data-sentry-label="Zawieszki dodatkowe"
                    @click="openAdditionalShippingLabelLabelDialog()"
                >
                    <v-icon left>
                        mdi-plus
                    </v-icon>
                    Zawieszki dodatkowe
                </v-btn>
                <v-btn
                    color="secondary"
                    medium
                    class="mr-4"
                    data-sentry-label="Zawieszki z kampanii"
                    @click="openCampaignShippingLabelDialog()"
                >
                    <v-icon left>
                        mdi-plus
                    </v-icon>
                    Zawieszka z kampanii
                </v-btn>
            </v-col>
        </v-row>
        <v-row justify="end">
            <v-col cols="12">
                <v-container fluid class="pa-0">
                    <v-row dense justify="end">
                        <v-col cols="12" sm="3" lg="2" xl="2">
                            <v-select
                                v-model="filters.type_id"
                                label="Typ"
                                :items="shippingLabelTypes"
                                item-value="id"
                                item-text="name"
                                no-data-text="Nie znaleziono typów"
                                solo
                                clearable
                                hide-details
                                single-line
                                dense
                                @click:clear="clearFilter('type_id')"
                                @change="changeFilter()"
                            />
                        </v-col>
                        <v-col cols="12" sm="3" lg="2" xl="2">
                            <v-select
                                v-model="filters.status_id"
                                label="Status"
                                :items="shippingLabelStatuses"
                                item-value="id"
                                item-text="name"
                                no-data-text="Nie znaleziono statusów"
                                solo
                                clearable
                                hide-details
                                single-line
                                dense
                                @click:clear="clearFilter('status_id')"
                                @change="changeFilter()"
                            />
                        </v-col>
                        <v-col cols="12" sm="3" lg="2" xl="2">
                            <v-text-field
                                v-model="filters.number"
                                append-icon="mdi-magnify"
                                label="Nr zawieszki"
                                single-line
                                clearable
                                solo
                                dense
                                hide-deatils
                                @keyup.enter="changeFilter()"
                                @click:append="changeFilter()"
                                @click:clear="clearFilter('number')"
                            />
                        </v-col>
                        <v-col cols="12" sm="3" lg="2" xl="2">
                            <v-text-field
                                v-model="filters.customer_name"
                                append-icon="mdi-magnify"
                                label="Klient"
                                single-line
                                clearable
                                solo
                                dense
                                hide-details
                                @keyup.enter="changeFilter()"
                                @click:append="changeFilter()"
                                @click:clear="clearFilter('customer_name')"
                            />
                        </v-col>
                        <v-col cols="12" sm="3" lg="2" xl="2">
                            <v-text-field
                                v-model="filters.source_object_number"
                                append-icon="mdi-magnify"
                                label="Numer zlecenia/zamówienia"
                                single-line
                                clearable
                                solo
                                dense
                                hide-details
                                @keyup.enter="changeFilter()"
                                @click:append="changeFilter()"
                                @click:clear="clearFilter('source_object_number')"
                            />
                        </v-col>
                    </v-row>
                </v-container>
            </v-col>
        </v-row>

        <v-row>
            <v-col cols="12">
                <v-card>
                    <v-data-table
                        :headers="headers"
                        :items="shippingLabels"
                        :loading="shippingLabelsLoading"
                        :footer-props="footerProps"
                        :server-items-length="pagination.itemsLength"
                        :page.sync="pagination.page"
                        :items-per-page.sync="pagination.itemsPerPage"
                        :mobile-breakpoint="0"
                        :item-class="setSelectedRow"
                        name="labelsData"
                        @pagination="updatePagination"
                    >
                        <template #item.createdAt="{item}">
                            {{ formatDate(item.createdAt) }}
                        </template>
                        <template #item.shippingLabelCustomer="{item}">
                            <template v-if="item.shippingLabelCustomer">
                                {{ item.shippingLabelCustomer.name }}
                            </template>
                            <template v-else>
                                -
                            </template>
                        </template>
                        <template #item.goodSource="{item}">
                            <template v-if="item.goodSource">
                                {{ item.goodSource.sourceObjectNumber }}
                            </template>
                            <template v-else>
                                -
                            </template>
                        </template>
                        <template #item.actions="{item}">
                            <div class="d-inline-flex">
                                <v-tooltip :open-delay="tooltipDelay" top>
                                    <template #activator="{on}">
                                        <v-btn
                                            v-if="isCarrierOrAdditionalLabel(item)"
                                            icon
                                            data-sentry-label="Generuj etykietę"
                                            v-on="on"
                                            @click="openPrintShippingLabelDialog(item)"
                                        >
                                            <v-icon color="primary">
                                                mdi-printer
                                            </v-icon>
                                        </v-btn>
                                    </template>
                                    <span>Generuj etykietę</span>
                                </v-tooltip>
                                <v-tooltip :open-delay="tooltipDelay" top>
                                    <template #activator="{on}">
                                        <v-btn
                                            v-if="!isCarrierOrAdditionalLabel(item)"
                                            icon
                                            data-sentry-label="Otwórz"
                                            v-on="on"
                                            @click="openShippingLabel(item.id, item.type.id)"
                                        >
                                            <v-icon color="teal">
                                                mdi-ballot
                                            </v-icon>
                                        </v-btn>
                                    </template>
                                    <span>Otwórz</span>
                                </v-tooltip>
                                <v-tooltip :open-delay="tooltipDelay" top>
                                    <template #activator="{on}">
                                        <v-btn
                                            icon
                                            data-sentry-label="Usuń"
                                            :disabled="!item.deletable"
                                            v-on="on"
                                            @click="showConfirmDeleteShippingLabel(item)"
                                        >
                                            <v-icon color="pink">
                                                mdi-delete
                                            </v-icon>
                                        </v-btn>
                                    </template>
                                    <span>Usuń</span>
                                </v-tooltip>
                            </div>
                        </template>
                    </v-data-table>
                </v-card>
            </v-col>
        </v-row>
    </v-container>
</template>

<script>
import router from '@/router'
import PageTitle from '@/components/common/PageTitle'
import ImportShippingLabelDialog from './Dialogs/ImportShippingLabelDialog'
import CarrierLabelDialog from './Dialogs/CarrierLabelDialog'
import AdditionalShippingLabelDialog from './Dialogs/AdditionalShippingLabelDialog'
import ConfirmDialog from '@/components/common/ConfirmDialog'

import dateFormatter from '@/mixins/dateFormatter'
import tooltipDelay from '@/mixins/tooltip'
import dataTableClassSetter from '@/mixins/dataTableClassSetter'
import pagination from '@/mixins/dataTablePagination'
import filters from '@/mixins/dataTableFilters'
import parse from '@/mixins/parse'
import { errorHandler } from '@/utils/errorHandler'
import { openPdfFile } from '@/utils/pdfHandler'
import CampaignShippingLabelDialog from './Dialogs/CampaignShippingLabelDialog'

const CAMPAIGN_LABEL_TYPE = 50

export default {
    name: 'LabelsV2',
    components: {
        PageTitle,
        ImportShippingLabelDialog,
        CarrierLabelDialog,
        AdditionalShippingLabelDialog,
        ConfirmDialog,
        CampaignShippingLabelDialog
    },
    mixins: [
        dateFormatter,
        tooltipDelay,
        pagination,
        filters,
        dataTableClassSetter,
        parse
    ],
    beforeRouteLeave(to, from, next) {
        if (!this.filtersCleared) {
            this.$store.dispatch('shipments/packageLabels/clearLabelsFilters')
            this.clearSelectedListItemId()
        }
        this.resetFiltersCleared()
        next()
    },
    data() {
        return {
            currentShippingLabel: {},
            confirmDeleteShippingLabelDialog: false,
            showImportShippingLabelDialog: false,
            showCarrierLabelDialog: false,
            campaignShippingLabelDialog: false,
            shippingLabel: {
                goodSource: {
                    sourceObjectNumber: null
                }
            },
            carrierLabelToPrintData: {},
            createFrom: null,
            actionLoading: {
                deleteShippingLabel: false
            },
            labelLoading: false,
            printShippingLabels: {
                printShippingLabels: []
            },
            additionalShippingLabel: {},
            additionalShippingLabelDialog: false,
            additionalShippingLabelLoading : false,
            pallets: [],
            destinations: [],
            carrierLabel: {},
            carrierLabelLoading: false,
            headers: [
                {
                    text: 'Nr zawieszki',
                    value: 'number',
                    sortable: false,
                },
                {
                    text: 'Data utworzenia',
                    value: 'createdAt',
                    sortable: false,
                    align: 'center',
                },
                {
                    text: 'Źródło danych',
                    value: 'type.name',
                    sortable: false,
                    align: 'center'
                },
                {
                    text: 'Numer zlecenia/zamówienia',
                    value: 'goodSource',
                    sortable: false,
                    align: 'center'
                },
                {
                    text: 'Klient',
                    value: 'shippingLabelCustomer',
                    sortable: false,
                    align: 'center'
                },
                {
                    text: 'Status',
                    value: 'status.name',
                    align: 'center',
                    sortable: false,
                },
                {
                    text: 'Akcje',
                    value: 'actions',
                    sortable: false,
                    align: 'center',
                }
            ]
        }
    },
    computed: {
        shippingLabelStatuses() {
            return this.$store.state.shipments.shipmentsLabels.shipmentsLabels.shippingLabelStatuses
        },
        shippingLabelTypes() {
            return this.$store.state.shipments.shipmentsLabels.shipmentsLabels.shippingLabelTypes
        },
        shippingLabels() {
            return this.$store.state.shipments.shipmentsLabels.shipmentsLabels.shippingLabels
        },
        shippingLabelsLoading() {
            return this.$store.state.shipments.shipmentsLabels.shipmentsLabels.shippingLabelsLoading
        },
        selectedLabelId() {
            return this.$store.state.common.selectedListItemId
        },
        filterQuery() {
            const filters = this.filters
            let query = ''

            for (let item in filters) {
                if (filters[item] != null && filters[item] !== '') {
                    query = query.concat('&', `${item}=${filters[item]}`)
                }
            }

            return query
        },
        importMapper() {
            return {
                'EcommerceOrder': 'orderId',
                'ShipmentsOrder': 'shippingOrderId',
            }
        }
    },
    beforeMount() {
        if (!this.savedPagination.pagination) {
            this.resetPagination()
        }
    },
    mounted() {
        this.getShippingLabels()
        this.getShippingLabelStatuses()
        this.getShippingLabelTypes()
        Promise.all([
            this.$store.dispatch('shipments/shipmentsOrders/getPackagesTypes', '?boxTypeId=3'),
            this.$store.dispatch('shipments/shipmentsLabels/getShippingLabelDestinations')
        ])
            .then(responses => {
                this.pallets = responses[0].data.results
                this.destinations = responses[1].data.results
            })
            .catch(error => {
                errorHandler(error)
            })
    },
    methods: {
        isCarrierOrAdditionalLabel(item) {
            return item.type.id === 30 || item.type.id === 40
        },
        openPrintShippingLabelDialog(item) {
            if (item.type.id === 30) {
                return this.openAdditionalShippingLabelLabelDialog(item)
            }
            if (item.type.id === 40) {
                return this.openPrintCarrierLabelDialog(item)
            }
        },
        getShippingLabels() {
            this.$store.dispatch('shipments/shipmentsLabels/getShippingLabels', {
                paginate: this.paginate(),
                query: this.filterQuery
            })
                .then(response => {
                    this.handlePaginationResponse(response)
                })
                .catch(error => {
                    errorHandler(error)
                })
        },
        getShippingLabelStatuses() {
            this.$store.dispatch('shipments/shipmentsLabels/getShippingLabelStatuses')
                .catch(error => {
                    errorHandler(error)
                })
        },
        getShippingLabelTypes() {
            this.$store.dispatch('shipments/shipmentsLabels/getShippingLabelTypes')
                .catch(error => {
                    errorHandler(error)
                })
        },
        openShippingLabel(id, typeId) {
            this.savePagination(this.$options.name)
            this.saveFiltersCleared()
            this.setSelectedListItemId(id)
            router.push({ 
                name: typeId === CAMPAIGN_LABEL_TYPE ? 'shipmentsPackageLabelsLabelsCampaignEdit' : 'shipmentsPackageLabelsLabelsEdit-v2',
                params: { id }
            }).catch(error => {
                errorHandler(error)
            })
        },
        openImportShippingLabelDialog(type) {
            this.showImportShippingLabelDialog = true
            this.createFrom = type
        },
        submitCreateShippingLabel(id) {
            this.$store.dispatch(`shipments/shipmentsLabels/createFrom${this.createFrom}`, {
                [this.importMapper[this.createFrom]] : id
            } )
                .then(response => {
                    const typeId = response.data.shippingLabelTypeId

                    this.$router.push({
                        name: typeId === CAMPAIGN_LABEL_TYPE ? 'shipmentsPackageLabelsLabelsCampaignEdit' : 'shipmentsPackageLabelsLabelsEdit-v2',
                        params: {id: response.data['shippingLabelId']}
                    })
                        .catch(error => {
                            errorHandler(error)
                        })
                })
                .catch(error => {
                    errorHandler(error)
                })
                .finally(() => {
                    this.closeImportShippingLabelDialog()
                })
        },
        submitCarrierLabel(payload) {
            this.carrierLabelLoading = true
            this.$store.dispatch('shipments/shipmentsLabels/createCarrierLabel', payload)
                .then(response => {
                    payload.statusId = 50 //wydrukowana
                    payload.readyToPrint = response.data.readyToPrint
                    payload.shippingLabelId = response.data.shippingLabelId
                    payload.id = response.data.shippingLabelId
                    payload.shippingLabelPositionAvailableGoods = response.data.shippingLabelPositionAvailableGoods
                    payload.shippingLabelPositions = response.data.shippingLabelPositions
                    this.printShippingLabels.printShippingLabels.push(payload)
                    Promise.all([
                        this.$store.dispatch('shipments/shipmentsLabels/printShippingLabel', this.printShippingLabels),
                        this.$store.dispatch('shipments/shipmentsLabels/updateShippingLabel', payload)
                    ])
                        .then(responses => {
                            openPdfFile(responses[0].data)
                            this.getShippingLabels()
                        })
                        .catch(error => {
                            errorHandler(error)
                        })
                        .finally(() => {
                            this.carrierLabelLoading = false
                            this.showCarrierLabelDialog = false
                            this.printShippingLabels.printShippingLabels = []
                            this.carrierLabel = {}
                        })
                })
                .catch(error => {
                    errorHandler(error)
                })
                .finally(() => {
                    this.carrierLabelLoading = false
                    this.showCarrierLabelDialog = false
                    this.carrierLabel = {}
                })
        },
        printCarrierShippingLabel(payload) {
            this.carrierLabelLoading = true

            this.printShippingLabels.printShippingLabels.push(payload)
            this.$store.dispatch('shipments/shipmentsLabels/printShippingLabel', this.printShippingLabels)
                .then(response => {
                    openPdfFile(response.data)
                })
                .catch(error => {
                    errorHandler(error)
                })
                .finally(() => {
                    this.carrierLabelLoading = false
                    this.showCarrierLabelDialog = false
                    this.printShippingLabels.printShippingLabels = []
                })
        },
        printAdditionalShippingLabel(payload) {
            this.additionalShippingLabelLoading = true

            this.printShippingLabels.printShippingLabels.push(payload)
            this.$store.dispatch('shipments/shipmentsLabels/printShippingLabel', this.printShippingLabels)
                .then(response => {
                    openPdfFile(response.data)
                })
                .catch(error => {
                    errorHandler(error)
                })
                .finally(() => {
                    this.additionalShippingLabelLoading = false
                    this.additionalShippingLabelDialog = false
                    this.printShippingLabels.printShippingLabels = []
                })
        },
        openPrintCarrierLabelDialog(item = {}) {
            this.carrierLabel = item
            this.showCarrierLabelDialog = true
        },
        closeImportShippingLabelDialog() {
            this.showImportShippingLabelDialog = false
            this.createFrom = null
        },
        closePrintCarrierLabelDialog() {
            this.showCarrierLabelDialog = false
        },
        openAdditionalShippingLabelLabelDialog(item = {}) {
            this.additionalShippingLabel = item
            this.additionalShippingLabelDialog = true
        },
        submitAdditionalShippingLabel(payload) {
            this.additionalShippingLabelLoading = true
            this.$store.dispatch('shipments/shipmentsLabels/createAdditionalShippingLabel', payload)
                .then(response => {
                    payload.statusId = 50 //wydrukowana
                    payload.shippingLabelId = response.data.shippingLabelId
                    payload.id = response.data.shippingLabelId
                    payload.readyToPrint = response.data.readyToPrint
                    payload.shippingLabelPositionAvailableGoods = response.data.shippingLabelPositionAvailableGoods
                    payload.shippingLabelPositions = response.data.shippingLabelPositions
                    this.printShippingLabels.printShippingLabels.push(payload)
                    Promise.all([
                        this.$store.dispatch('shipments/shipmentsLabels/printShippingLabel', this.printShippingLabels),
                        this.$store.dispatch('shipments/shipmentsLabels/updateShippingLabel', payload)
                    ])
                        .then(responses => {
                            openPdfFile(responses[0].data)
                            this.getShippingLabels()
                        })
                        .catch(error => {
                            errorHandler(error)
                        })
                        .finally(() => {
                            this.additionalShippingLabelLoading = false
                            this.additionalShippingLabelDialog = false
                            this.printShippingLabels.printShippingLabels = []
                            this.additionalShippingLabel = {}
                        })
                })
                .catch(error => {
                    errorHandler(error)
                })
                .finally(() => {
                    this.additionalShippingLabelLoading = false
                    this.additionalShippingLabelDialog = false
                    this.additionalShippingLabel = {}
                })
        },
        closeAdditionalShippingLabelDialog() {
            this.additionalShippingLabelDialog = false
        },
        getLinkToCustomer(id) {
            return `/customers/customers/edit/${id}`
        },
        showConfirmDeleteShippingLabel(shippingLabel) {
            this.confirmDeleteShippingLabelDialog = true
            this.currentShippingLabel = shippingLabel
        },
        closeConfirmDeleteShippingLabelDialog() {
            this.confirmDeleteShippingLabelDialog = false
            this.currentShippingLabel = {}
        },
        deleteShippingLabel(shippingLabel) {
            this.actionLoading.deleteShippingLabel = true
            this.$store.dispatch('shipments/shipmentsLabels/deleteShippingLabel', shippingLabel.id)
                .then(() => {
                    this.getShippingLabels()
                })
                .catch(error => errorHandler(error))
                .finally(() => {
                    this.actionLoading.deleteShippingLabel = false
                    this.confirmDeleteShippingLabelDialog = false
                })
        },
        changeFilter() {
            this.resetPagination()
            this.getShippingLabels()
        },
        updatePagination(pagination) {
            this.pagination = pagination
            this.evaluateSavedPagination(this.$options.name)
            if (pagination.pageCount !== 0 && !this.paginationSettings.paginationPending && !this.savedPagination.pagination) {
                this.getShippingLabels()
            }
            this.clearPaginationPending()
        },
        setSelectedRow(item) {
            if (item.id === this.selectedLabelId) {
                return 'isSelected'
            }
        },
        openCampaignShippingLabelDialog() {
            this.campaignShippingLabelDialog = true
        },
        closeCampaignShippingLabelDialog() {
            this.campaignShippingLabelDialog = false
            this.getShippingLabels()
        },
    }
}
</script>
